import ExternalLinksBaseHandler from '../external_links_base_handler';

/**
 * Handler for FYP
 */
class ExternalLinksSportHandler extends ExternalLinksBaseHandler {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksSportHandler';
    static HandlerName = 'sport';

    /**
     * Overrides base class executePostMessageAction
     * @param postMessageData
     */
	executePostMessageAction(postMessageData) {
    }

}

export default ExternalLinksSportHandler;